import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_629 implements Validator {

    public static id = 'CTRL_629';
    private message = 'error.ctr_629';


    public LOG: LogService = new LogService(CTRL_629);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_629.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLotMarche = rg.substr(rg.length - 1);

                const personneMorale = ctrl.value.rgCtrls.personneMorale.replace('INDEX_629_1', numLotMarche);
                const codeIdentificationNational = ctrl.value.rgCtrls.codeIdentificationNational.replace('INDEX_629_1', numLotMarche);
                const ville = ctrl.value.rgCtrls.ville.replace('INDEX_629_1', numLotMarche);
                const pays = ctrl.value.rgCtrls.pays.replace('INDEX_629_1', numLotMarche);
                const cp_e = ctrl.value.rgCtrls.cp_e.replace('INDEX_629_1', numLotMarche);
                const cp = ctrl.value.rgCtrls.cp.replace('INDEX_629_1', numLotMarche);
                const nomvoie = ctrl.value.rgCtrls.nomvoie.replace('INDEX_629_1', numLotMarche);
                const typevoie = ctrl.value.rgCtrls.typevoie.replace('INDEX_629_1', numLotMarche);
                const num = ctrl.value.rgCtrls.num.replace('INDEX_629_1', numLotMarche);
                const tel = ctrl.value.rgCtrls.tel.replace('INDEX_629_1', numLotMarche);
                const fax = ctrl.value.rgCtrls.fax.replace('INDEX_629_1', numLotMarche);
                const mel = ctrl.value.rgCtrls.mel.replace('INDEX_629_1', numLotMarche);
                const url = ctrl.value.rgCtrls.url.replace('INDEX_629_1', numLotMarche);
                const nomvoie_e = ctrl.value.rgCtrls.nomvoie_e.replace('INDEX_629_1', numLotMarche);
                const typevoie_e = ctrl.value.rgCtrls.typevoie_e.replace('INDEX_629_1', numLotMarche);
                const num_e = ctrl.value.rgCtrls.num_e.replace('INDEX_629_1', numLotMarche);

                const personneMoraleWithStepId = map.get(personneMorale);
                const codeIdentificationNationalWithStepId = map.get(codeIdentificationNational);
                const villeWithStepId = map.get(ville);
                const paysWithStepId = map.get(pays);
                const cp_eWithStepId = map.get(cp_e);
                const cpWithStepId = map.get(cp);
                const nomvoieWithStepId = map.get(nomvoie);
                const typevoieWithStepId = map.get(typevoie);
                const numWithStepId = map.get(num);
                const telWithStepId = map.get(tel);
                const faxWithStepId = map.get(fax);
                const melWithStepId = map.get(mel);
                const urlWithStepId = map.get(url);
                const nomvoie_eWithStepId = map.get(nomvoie_e);
                const typevoie_eWithStepId = map.get(typevoie_e);
                const num_eWithStepId = map.get(num_e);

                const personneMoraleCtrl = form.controls[personneMoraleWithStepId];
                const codeIdentificationNationalCtrl = form.controls[codeIdentificationNationalWithStepId];
                const villeCtrl = form.controls[villeWithStepId];
                const paysCtrl = form.controls[paysWithStepId];
                const cp_eCtrl = form.controls[cp_eWithStepId];
                const cpCtrl = form.controls[cpWithStepId];
                const nomvoieCtrl = form.controls[nomvoieWithStepId];
                const typevoieCtrl = form.controls[typevoieWithStepId];
                const numCtrl = form.controls[numWithStepId];
                const telCtrl = form.controls[telWithStepId];
                const faxCtrl = form.controls[faxWithStepId];
                const melCtrl = form.controls[melWithStepId];
                const urlCtrl = form.controls[urlWithStepId];
                const nomvoie_eCtrl = form.controls[nomvoie_eWithStepId];
                const typevoie_eCtrl = form.controls[typevoie_eWithStepId];
                const num_eCtrl = form.controls[num_eWithStepId];

                if (paysCtrl.value === '' || paysCtrl.value === null) {
                    if (villeCtrl.value === '' &&
                    (codeIdentificationNationalCtrl.value !== '' ||
                    personneMoraleCtrl.value !== '' ||
                    paysCtrl.value !== '' ||
                    cpCtrl.value !== '' ||
                    nomvoieCtrl.value !== '' ||
                    typevoieCtrl.value !== '' ||
                    numCtrl.value !== '' ||
                    telCtrl.value !== '' ||
                    faxCtrl.value !== '' ||
                    melCtrl.value !== '' ||
                    urlCtrl.value !== '' )) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }
                } else {
                    if (villeCtrl.value === '' &&
                    (codeIdentificationNationalCtrl.value !== '' ||
                    personneMoraleCtrl.value !== '' ||
                    paysCtrl.value !== '' ||
                    cp_eCtrl.value !== '' ||
                    telCtrl.value !== '' ||
                    faxCtrl.value !== '' ||
                    melCtrl.value !== '' ||
                    urlCtrl.value !== '' ||
                    nomvoie_eCtrl.value !== '' ||
                    typevoie_eCtrl.value !== '' ||
                    num_eCtrl.value !== '')) {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    } else {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    }

                }
            }
        }
    }
}